import { atom } from 'nanostores'
import { Request, ServicesSelection, InsurancePassengers } from './dto/services.dto';

export const servicesInitialization = atom<Request>();
export const servicesSelection = atom<ServicesSelection>();
export const insurancePassengers = atom<InsurancePassengers>();

export function setInitialSaleServicesRequest(request: Request) {
  servicesInitialization.set(request);
};

export function getInitialSaleServicesRequest() {
  return servicesInitialization.get();
};

export function setPassengersServicesSelection(passengersServicesSelection) {
  servicesSelection.set(passengersServicesSelection);
};

export function getPassengersServicesSelection() {
  return servicesSelection.get();
};

export function setInsurancePassengersMMB(passengersInsurance) {
  insurancePassengers.set(passengersInsurance);
};

export function getInsurancePassengersMMB() {
  return insurancePassengers.get();
}